/*
 * 房价变更切换
 */
import React from 'react';
import { Radio, RadioChangeEvent, Tooltip } from 'antd';
import intl from 'react-intl-universal';

import { RoomExchangeType } from '@/redux/reducers/reservation/base.d';

import styles from './index.module.scss';

interface IProps {
  value: RoomExchangeType; // 换房类型
  isMultiType: boolean; // 是否是多种入住类型
  onChange: (type: RoomExchangeType) => void;
}

const Index: React.FC<IProps> = (props) => {
  const handleTypeChange: (event: RadioChangeEvent) => void = (event) => {
    props.onChange(event.target.value);
  };

  return (
    <div className={styles.exchangeTypeWrapper}>
      <div className={styles.exchangeTitle}>{intl.get('drawer_exchange_type_block_title')}</div>
      <div>
        <Radio.Group value={props.value} onChange={handleTypeChange}>
          <Radio value={RoomExchangeType.KeepSame}>
            {intl.get('drawer_exchange_type_same_option')}
          </Radio>
          {props.isMultiType ? (
            <Tooltip title={intl.get('drawer_exchange_type_diff_disabled_message')}>
              <Radio value={RoomExchangeType.Modify} disabled>
                {intl.get('drawer_exchange_type_diff_option')}
              </Radio>
            </Tooltip>
          ) : (
            <Radio value={RoomExchangeType.Modify}>
              {intl.get('drawer_exchange_type_diff_option')}
            </Radio>
          )}
        </Radio.Group>
      </div>
    </div>
  );
};

export default Index;
